import { adminData } from "~/admin/data";

export const PROPS_CAN_DELETE = adminData.PROPS_CAN_DELETE;
export const PROPS_CLASSBREAKS = "classBreaks";
export const PROPS_COLOR_RAMP_GUID = "colorRampGuid";
export const PROPS_DEFINED_LEGEND_GUID = "ownerDefinedLegendGuid";
export const PROPS_LAYER_TYPE_NAME = "layerTypeName";
export const PROPS_ORG_LEVELS = "orgLevels";
export const PROPS_ORG_LEVEL_GUID = "orgLevelGuid";
export const PROPS_ORG_LEVEL_NAME = "orgLevelName";
export const PROPS_ORG_LEVEL_CITY = "city";
export const PROPS_ORG_LEVEL_STATE = "state";
export const PROPS_LOCATION = "location";
export const PROPS_LOCATIONS = "locations";
export const PROPS_LOCATION_NAMES = "locationNames";
export const PROPS_DL_ATTRIBUTE_GUID = "importAttributeGuid";
export const PROPS_DL_ATTRIBUTE_NAME = "attributeName";
export const PROPS_ATTRIBUTE_GUID = "sampleAttributeGuid";
export const PROPS_ATTRIBUTE_NAME = "sampleAttributeDescription";
export const PROPS_CROP_GUID = "cropGuid";
export const PROPS_CROP_NAME = "cropName";
export const PROPS_CROP_PURPOSE_PICKLIST_GUID = "picklistValueGuid";
export const PROPS_CROP_PURPOSE_GUID = "cropPurposeGuid";
export const PROPS_DL_CROP_PURPOSE_NAME = "cropPurposeName";
export const PROPS_CROP_PURPOSE_NAME = "value";
export const PROPS_PRODUCT_GUID = "productGuid";
export const PROPS_DL_PRODUCT_NAME = "productName";
export const PROPS_PRODUCT_NAME = "name";
export const PROPS_CREATED_DATE = "createdDate";
export const PROPS_MODIFIED_DATE = "modifiedDate";
